import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import RelationshipLinkButton from './RelationshipLinkButton';

const useStyles = buildUseStyles('RelationshipLinkButtons', ((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
  },
  rootHidden: { display: 'none' },
})));

const RelationshipLinkButtons = ({ resource, onClick }) => {
  const classes = useStyles();

  const linkButtonRelationships = resource.relationships().list().filter((r) => {
    return r.meta('relationshipType') === 'linkButton';
  });

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootHidden]: linkButtonRelationships.length === 0,
      })}
    >
      {linkButtonRelationships.map((rel) => {
        return (
          <RelationshipLinkButton
            key={rel.id()}
            relationship={rel}
            onClick={() => {
              onClick(rel);
            }}
          />
        );
      })}
    </Box>
  );
};

RelationshipLinkButtons.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RelationshipLinkButtons;
